import jwt_decode from 'jwt-decode';

import { store } from '@/store/configuration';
import { IAccessTokenDecoded } from '@/store/models/auth.model';

export const getSupportId = () => {
  const state = store.getState();
  const accessToken = state.auth.token?.access_token;

  if (!accessToken) throw new Error('Access Token not found');

  const jwtDecoded = jwt_decode<IAccessTokenDecoded>(accessToken);
  const supportUserId = jwtDecoded.sub;
  return supportUserId;
};
